import { render } from "./LoadingData.vue?vue&type=template&id=09fc3503&scoped=true"
import script from "./LoadingData.vue?vue&type=script&lang=js"
export * from "./LoadingData.vue?vue&type=script&lang=js"

import "./LoadingData.vue?vue&type=style&index=0&id=09fc3503&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fc3503"]])

export default __exports__